import { CreateQuestionaireDTO } from "@/domain/dto/CreateQuestionaireDTO";
import { ListQuestionairesQueryParamsDTO } from "@/domain/dto/ListQuestionairesQueryParamsDTO";
import { UpdateQuestionaireDTO } from "@/domain/dto/UpdateQuestionaireDTO";
import { QuestionaireCreateResponseDTO } from "@/infrastructure/dto/Questionaires/QuestionaireCreateResponseDTO";
import { QuestionaireDetailResponseDTO } from "@/infrastructure/dto/Questionaires/QuestionaireDetailResponseDTO";
import { QuestionaireListResponseDTO } from "@/infrastructure/dto/Questionaires/QuestionaireListResponseDTO";
import endpoints from "@/infrastructure/http/endpoints";
import { NetworkService } from "@/services/NetworkService";
import { IQuestionaireRemoteDataSource } from "../../interfaces/remote/IQuestionaireRemoteDataSource";

export class QuestionaireRemoteDataSource implements IQuestionaireRemoteDataSource {
    network
    constructor(ntw: NetworkService) {
        this.network = ntw
    }

    create(params: CreateQuestionaireDTO): Promise<QuestionaireCreateResponseDTO> {
        return this.network.post(endpoints.questionaires, params)
    }

    list(params: ListQuestionairesQueryParamsDTO): Promise<QuestionaireListResponseDTO> {
        return this.network.get(endpoints.questionaires, params)
    }

    show(id: string): Promise<QuestionaireDetailResponseDTO> {
        return this.network.get(`${endpoints.questionaires}/${id}`)
    }
    update(id: string, params: UpdateQuestionaireDTO): Promise<void> {
        return this.network.put(`${endpoints.questionaires}/${id}`, params)
    }
}
